import React from 'react'
import './trsutedCompanies.scss'
import { useHistory } from 'react-router-dom'

import Button from '../button/Button'

import Skynet360 from '../../assets/Skynet360.png'
import Geenrator_industry from '../../assets/companies/Geenrator_industry.png'
import MC_Systems from '../../assets/companies/MC_Systems.png'
import AYA_Valuators from '../../assets/companies/AYA_Valuators.png'
import JN_Group from '../../assets/companies/JN_Group.png'
import Elite_Embassy from '../../assets/companies/Elite_Embassy.png'


import { useMediaQuery } from 'react-responsive'

const TrustedCompanies = () => {
  const isMobile = useMediaQuery({ maxWidth: 1250 })
  const history = useHistory()
  return (
    <div className="trusted_companies">
      {isMobile ? (
        <div className="trusted_companies__wrapper">
          <div className="trusted_companies__wrapper__price">
            <h2 className="secondary__heading">
              Ready to become Virtualize? Let’s grow your business today.
            </h2>
            <Button onclick={() => history.push('/price-plan')} text="Plans & Pricing" type="primary" />
          </div>
          <div className="trusted_companies__wrapper__mobile_img">
            <img src={Geenrator_industry} alt="" />
            <img src={JN_Group} alt="" />
            <img src={AYA_Valuators} alt="" />
            <img src={MC_Systems} alt="" />
            <img src={Elite_Embassy} alt="" />
            <img src={Skynet360} alt="" />
          </div>
        </div>
      ) : (
        <div className="trusted_companies__wrapper">
          <img src={Geenrator_industry} alt="" />
          <img src={JN_Group} alt="" />
          <img src={AYA_Valuators} alt="" />
          <div className="trusted_companies__wrapper__price">
            <h2 className="secondary__heading">
              Ready to become Virtualize? Let’s grow your business today.
            </h2>
            <Button onclick={() => history.push('/price-plan')} text="Plans & Pricing" type="primary" />
          </div>
          <img src={MC_Systems} alt="" />
          <img src={Elite_Embassy} alt="" />
          <img src={Skynet360} alt="" />
        </div>
      )}
    </div>
  )
}

export default TrustedCompanies
